require('./Array.forEach');
require('./Array.isArray');
require('./AudioContextMonkeyPatch');
require('./console');
require('./Function.bind');
require('./Math.trunc');
require('./performance.now');
require('./requestAnimationFrame');
require('./Uint32Array');



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/src/polyfills/index.js
// module id = 432
// module chunks = 0